module.exports = __webpack_public_path__ + "static/media/Candidate_header.26348603.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Candidate_header.PNG
// module id = 458
// module chunks = 0